import React, { useEffect, useState } from "react";
import { BOOKINGS } from "../data/shop";
import "./NavBar.css";

const LINKS = [
  { href: "#about", label: "About" },
  { href: "#pricing", label: "Prices" },
  { href: "#wall", label: "Wall" },
  { href: "#live", label: "Live" },
  { href: "#visit", label: "Visit" },
];

export const NavBar = () => {
  const [stuck, setStuck] = useState(false);
  const [open, setOpen] = useState(false);

  // The bar stays out of the way over the hero and fades in once you move.
  useEffect(() => {
    const onScroll = () => {
      const past = window.scrollY > 100;
      setStuck(past);
      if (!past) setOpen(false);
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header className={`navbar-shop${stuck ? " is-stuck" : ""}`}>
      <div className="navbar-shop__inner">
        <a className="navbar-shop__brand" href="#top">
          <img src="/assets/randysbarbershop.png" alt="Randy's Barber Shop" />
        </a>

        <button
          type="button"
          className="navbar-shop__toggle"
          aria-expanded={open}
          aria-label="Toggle menu"
          onClick={() => setOpen((value) => !value)}
        >
          <span />
          <span />
          <span />
        </button>

        <nav className={`navbar-shop__nav${open ? " is-open" : ""}`}>
          {LINKS.map((link) => (
            <a key={link.href} href={link.href} onClick={() => setOpen(false)}>
              {link.label}
            </a>
          ))}
          <a
            className="btn-shop navbar-shop__cta"
            href={BOOKINGS[0].url}
            target="_blank"
            rel="noopener noreferrer"
            onClick={() => setOpen(false)}
          >
            Book Online
          </a>
        </nav>
      </div>
    </header>
  );
};
